import request from '@/utils/request'

/**
 * 查询会员等级列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopVipLevel(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser.queryShopVipLevel',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加会员等级
 * @param {Object} data 会员等级数据
 * @returns {Promise} Promise对象
 */
export function saveShopVipLevel(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser/saveShopVipLevel',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改会员等级
 * @param {Object} data 会员等级数据
 * @returns {Promise} Promise对象
 */
export function updateShopVipLevel(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser/updateShopVipLevel',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除会员等级
 * @param {Object} data 删除参数
 * @returns {Promise} Promise对象
 */
export function deleteShopVipLevel(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVipUser/deleteShopVipLevel',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}